import React from 'react';
import styled from "styled-components";

const ScoreBox = styled.div`
  border-radius: ${props => props.borderRadius};
  color: #262626;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${props => props.width};
  height: ${props => props.height};
  background: linear-gradient(90deg, #4D92FD 0%, #3EF4D8 100%);
  font-weight: 700;
  font-size: ${props => props.fontSize};
`;
const GradientScoreBox = ({children,fontSize = '18px',width = '56px',height = '29px',borderRadius='8px'}) => {
    return (
        <ScoreBox fontSize={fontSize} width={width} height={height} borderRadius={borderRadius}>
            {children}
        </ScoreBox>
    );
};

export default GradientScoreBox;